import {useState} from "react"
import { Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import {toast} from 'react-hot-toast';
import { useNavigate } from "react-router-dom";

export default function AddMock(){
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState('');
    const [errors, setErrors] = useState({});
    const [newMock, setNewMock] = useState({
        name:'',
        subject:'',
        grade_category:'',
        grade_level:''
    })
    
    // const [selectedFile, setSelectedFile] = useState(null)

    const handleChange = (e)=>{
        setNewMock({...newMock, [e.target.name]: e.target.value})
    }

    // const handleFileChange = (e)=>{
    //     //setNewPaper({...newPaper, paper: e.target.files[0]})
    //     const file = e.target.files[0];
    //     if(file){
    //         setNewPaper({...newPaper, paper : file})
    //     } 
    // }

    const handleSubmit = async (event)=>{
        event.preventDefault();
        const {name, subject, grade_category, grade_level} = newMock     
        
        event.preventDefault();
        let isValid = true;
        const newErrors = {};

        if(!newMock.subject){
            newErrors.subject = 'Subject is required';
            isValid = false;
        }
        if(!newMock.grade_category){
            newErrors.grade_category = 'Category is required';
            isValid = false;
        }
        if(!newMock.grade_level){
            newErrors.grade_level = 'Level is required';
            isValid = false;
        }
        if(!newMock.name){
            newErrors.name = 'Name is required';
            isValid = false;
        }

        setErrors(newErrors);

        if(isValid){

            const user = JSON.parse(localStorage.getItem("user"));

            console.log(user.accessToken);

            try {
                const response = await axios.post('https://coda.easylinksmw.com/api/mocks/add', newMock, {
                    onUploadProgress : (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setUploadProgress(percentCompleted);
                },           
            });
            console.log('Response: ', response.data);
            toast.success('Paper uploaded succcessfully')
            //navigate('/papers');
            //window.location.reload();

            setNewMock({
                name:'',
                subject:'',
                grade_category:'',
                grade_level:''               
            });

            } catch (error) {
                // The request was made and the server responded with a status code
                console.error('Upload error:', error);
                //console.error('Status code:', error.response.status);
                toast.error('Paper uploaded Failed. Try again')
                navigate('/create');            
            } 
        }        
    }
    
    return(
        <div style={{marginTop: 20}}>
            <div className="row">
                <div className="col-md-6 offset-md-3">
                <h3 className="text-center ">Upload New Mock </h3>
                <Form encType ="multipart/form-data" method="post">
                    {/* <Form.Group className="mb-3" controlId="paper_name">
                        <Form.Label>Paper Name</Form.Label>
                        <Form.Control onChange={handleChange} name="paper_name" value={newPaper.paper_name}  type="text" placeholder="paper name" />
                    </Form.Group> */}
                    <Form.Group className="mb-3" controlId="paper_subject">
                        <Form.Label>Name</Form.Label>
                        <Form.Control onChange={handleChange} name="name" value={newMock.name}  type="text" placeholder="Input mock name" required/>
                        {errors.subject && <p className="error">{errors.name}</p>}
                    </Form.Group>
					<Form.Group className="mb-3" controlId="paper_subject">
                        <Form.Label>Subject</Form.Label>
                        <Form.Control onChange={handleChange} name="subject" value={newMock.subject}  type="text" placeholder="Input subject" />
                        {errors.subject && <p className="error">{errors.subject}</p>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="phone">
                        <Form.Label>Grade Category</Form.Label>
                        <Form.Select onChange={handleChange} name="grade_category" value={newMock.grade_category}  type="text" placeholder="Category" required>
                            <option>Select Grade</option>
                            <option value="JCE">JCE</option>
                            <option value="MSCE">MSCE</option>
                        </Form.Select>
                        {errors.grade_category && <p className="error">{errors.grade_category}</p>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="grade_level">
                        <Form.Label>Grade Level</Form.Label>
                        <Form.Select onChange={handleChange} name="grade_level" value={newMock.grade_level}  type="text" placeholder="iInput Grade level" required>
                            <option>Select Level</option>
                            <option value="Form 1">Form 1</option>
                            <option value="Form 2">Form 2</option>
                            <option value="Form 3">Form 3</option>
                            <option value="Form 4">Form 4</option>
                        </Form.Select>
                        {errors.grade_level && <p className="error">{errors.grade_level}</p>}
                    </Form.Group>
                    <Button
                        style={{width:'100%', marginTop:'1rem'}} 
                        onClick={handleSubmit} 
                        variant="primary"
                    >
                        Submit
                    </Button>
                </Form>
                </div>
            </div>           
        </div>
    )
}